/**
 * Zgoda na newsletter zaznaczana przy okazji innego formularza - rejestracji konta
 * albo skladania zamowienia. edrone przyjmuje 'subscribe' wylacznie z przegladarki,
 * wiec zdarzenie zglaszamy w momencie wyslania formularza.
 * Formularz newslettera w stopce i popup obsluzone sa w modules/button-events.js.
 */
const CONSENT_SELECTOR = 'input[name="gsfNewsletter"], input[name="NewsletterAccepted"]';

export default function () {
    document.querySelectorAll(CONSENT_SELECTOR).forEach(consent => {
        const form = consent.closest('form');

        if (!form) return;

        form.addEventListener('submit', function () {
            if (!consent.checked || !window._edrone || !window._edrone.app_id) return;

            const emailField = form.querySelector('input[name="email"]');

            if (!emailField || !emailField.value) return;

            window._edrone.email = emailField.value;
            window._edrone.customer_tags = consent.getAttribute('name') === 'NewsletterAccepted' ? 'Koszyk' : 'Rejestracja';
            window._edrone.action_type = 'subscribe';

            try {
                window._edrone.init();
            } catch (error) {
                console.log(error);
            }
        });
    });
}
